module.exports = __webpack_public_path__ + "e3fff8389918100d1f2991bca3a0bf3a.png";